import Vue from 'vue';
import VueRouter from 'vue-router';
import serviceProvider from '@/services/service-provider';
import LandingPage from '../views/LandingPage.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/r',
    component: () => import(/* webpackChunkName: "loggedoutflow" */ '../views/LoggedOutLayout.vue'),
    children: [
      {
        path: 'signup',
        name: 'Signup',
        component: () => import('../views/Signup.vue'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('../views/Login.vue'),
      },
    ],
  },
  {
    path: '/h',
    name: 'Home',
    component: () => import(/* webpackChunkName: "layout" */ '../views/Layout.vue'),
    redirect: '/h/feed',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'feed',
        name: 'Feed',
        component: () => import(/* webpackChunkName: "feed" */ '../views/Feed.vue'),
      },
      {
        path: 'games/:id',
        name: 'DetailGames',
        component: () => import(/* webpackChunkName: "games" */ '../views/GameDetail.vue'),
      },
      {
        path: 'profile/:id',
        name: 'Profile',
        redirect: '/h/profile/:id/activities',
        component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
        children: [
          {
            path: 'activities',
            name: 'ProfileActivities',
            component: () => import(/* webpackChunkName: "profile" */ '../views/ProfileActivities.vue'),
          },
          {
            path: 'about',
            name: 'ProfileAbout',
            component: () => import(/* webpackChunkName: "profile" */ '../views/ProfileAbout.vue'),
          },
          {
            path: 'edit',
            name: 'ProfileEdit',
            component: () => import(/* webpackChunkName: "profile" */ '../views/ProfileEdit.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = await serviceProvider.auth.isAuthenticated();

  // If we hit the landing page while logged in, redirect user to Home
  if (to.name === 'LandingPage' && isLoggedIn) {
    next({ name: 'Home' });
    return;
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isLoggedIn) {
      next({
        name: 'Login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
